
import { RouterModule, Routes } from '@angular/router';
import {
  BiografiaComponent,
  ObrasComponent,
  ContactoComponent,
  OrganeriaComponent,
  ProcesoComponent,
  MainComponent
} from "./components/index.paginas";

const app_routes: Routes = [
  { path: '', component: MainComponent },
  /*
  { path: 'biografia', component: BiografiaComponent },
  { path: 'proceso', component: ProcesoComponent },
  { path: 'obras', component: ObrasComponent },
  { path: 'organeria', component: OrganeriaComponent },
  { path: 'contacto', component: ContactoComponent },*/
  { path: '**', pathMatch: 'full', redirectTo: ''}
];

export const app_routing = RouterModule.forRoot(app_routes, { useHash: false });



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/app.routes.ts